import firebase from 'firebase/app'
import 'firebase/storage'
import 'firebase/firestore'
import 'firebase/auth'
import {firestorePlugin} from 'vuefire'
import FireStoreUploader from 'firebase-storage-uploader'
import Vue from 'vue';
import {inIframe} from './generalFunctions';


if(!inIframe()) {


  firebase.initializeApp(setFBConfig())
// set auto refresh every 30minutes
  firebase.firestore().settings({
        cacheSizeBytes:   1048576, // firebase.firestore.CACHE_SIZE_UNLIMITED
      }
  );
  setInterval(() => {

    firebase.auth().currentUser.getIdTokenResult(true)
         .then(function (idToken) {

        })
  }, 60000 *30)

  // firebase.firestore().enablePersistence()
  //     .catch(function (err) {
  //       if(err.code == 'failed-precondition') {
  //
  //         // Multiple tabs open, persistence can only be enabled
  //         // in one tab at a a time.
  //         // ...
  //       } else if(err.code == 'unimplemented') {
  //         // The current browser does not support all of the
  //         // features required to enable persistence
  //         // ...
  //       }
  //     });
  Vue.prototype.$FB = firebase.firestore()
  // Vue.prototype.$FB_STORAGE = firebase.storage()
  // Vue.prototype.$FB_UPLOADER = new FireStoreUploader(firebase.storage())
  Vue.prototype.$FBClient = firebase


}
export {
  firebase, firestorePlugin, FireStoreUploader
}


function setFBConfig() {
  if(!process.env.VUE_APP_FB_CONFIG) {
    console.warn('missing VUE_APP_FB_CONFIG')
  } else {
    return JSON.parse(process.env.VUE_APP_FB_CONFIG)
  }
}
